import React from 'react'
import { BottomSheet } from '@yanolja-rnd/nol-design-system'
import IframeResizer from 'iframe-resizer-react'
import useDeviceType from '~/app/utils/useDeviceType'
import { zIndexExtra } from '~/app/components/styles/units'

interface IframeBottomSheetProps {
  /** 바텀 시트 오픈 여부 */
  isOpen: boolean
  /** 바텀 시트 닫기 핸들러 */
  onClose: () => void
  /** 헤더 타이틀 */
  header: string
  /** 바텀 시트 내용 (iframe URL) */
  iframeUrl: string
}

const IframeBottomSheet: React.FC<IframeBottomSheetProps> = ({
  isOpen,
  onClose,
  header,
  iframeUrl,
}) => {
  const deviceType = useDeviceType()
  const isPc = deviceType === 'etc'

  return (
    <BottomSheet
      isOpen={isOpen}
      os={deviceType}
      height="full"
      header={header}
      onClose={onClose}
      dialogOptions={{
        height: 'full',
        className: 'w-[600px]',
        onBackdropClick: () => {
          isPc && onClose()
        },
      }}
      zIndex={zIndexExtra}
    >
      <IframeResizer
        src={iframeUrl}
        className="px-16 pf-pc:p-0"
        scrolling
        heightCalculationMethod="max"
        style={{
          width: '100%',
          // PC 모드: PcDialogSheet 컨테이너 maxHeight(100vh-200px) - 헤더·패딩 약 120px
          height: isPc ? 'calc(100vh - 320px)' : '100%',
        }}
      />
    </BottomSheet>
  )
}

export default IframeBottomSheet
